module.exports = __webpack_public_path__ + "img/whole.4183d577.jpg";